module.exports = __webpack_public_path__ + "img/procreate-tablet_jp.0d75c48.jpg";